import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

// Components
import CmsPageForm from './CmsPageForm';
import WeddingInfoForm from './entities/WeddingInfoForm';
import HomepageForm from './entities/HomepageForm';
import Accordion from '../../common/ui/Accordion';

// Actions
import { activatePage } from '../../../actions/website/PageActions';

// Utils
import featureFlags from '../../../util/featureFlags';
import { EDIT_PAGE_COMPONENTS } from './util/constants';

// Flags

const isCmsPageFormV2 = featureFlags.get('isCmsPageFormV2');

/* const EDIT_PAGE_COMPONENTS = {
  WEDDING_PARTY: {
    page: WeddingPartyMembers,
    preview: WebsitePreview,
  },
  POI: {
    page: Pois,
    preview: WebsitePreview
  },
  FAQ: {
    page: Faqs,
    preview: WebsitePreview,
  },
  TRAVEL: {
    page: Travel,
    preview: WebsitePreview,
  },
  REGISTRY: {
    page: isWebsiteRegistryRedisgn ? RegistryV2 : Registry,
    preview: RegistryPreview,
  },
  PHOTO: {
    page: Photos,
    preview: WebsitePreview,
  },
  HOME: {
    page: HomepageSections,
    preview: WebsitePreview,
  },
  EVENT: {
    page: Events,
    preview: WebsitePreview,
  },
  RSVP: {
    page: isWebsiteRSVPRedisgn ? RsvpContainer : Rsvp,
    preview: isWebsiteRSVPRedisgn ? undefined :  WebsitePreview,
  },
}; */



const  EditPage = ({
  pageKey,
  page,
  activateCmsPage,
  theme,
}) => {
  const pageType = page ? page.type : undefined;
  const CurrentPage = pageType ? EDIT_PAGE_COMPONENTS[pageType].page : undefined;
  const CurrentPreview = pageType ? EDIT_PAGE_COMPONENTS[pageType].preview : undefined;
  const isHomePage = pageType === 'HOME';
  const themeKey = theme.key || undefined;
  const themeFont = theme.font_name || undefined;
  const isDev = window.location.hostname === 'localhost' || window.location.hostname === 'qa.zola.com';
  const cloudfront = isDev ? 'https://d2wzwlp3rxwsn1.cloudfront.net' : 'https://d2gt2lt628wbyx.cloudfront.net';
  const pageAccordionItems = [
    {
      heading: 'Page Header',
      body: CmsPageForm,
      props: { page },
    },
  ];
  const homepageAccordionItems = [
    {
      heading: 'Wedding Summary',
      body: WeddingInfoForm,
      props: { page },
    },
    {
      heading: 'Page Header & Footer',
      body: HomepageForm,
      props: { page },
    },
  ];
  const accordionItems = isHomePage ? homepageAccordionItems : pageAccordionItems;

  useEffect(() => {
    if (pageKey) activateCmsPage(pageKey);
  }, [pageKey, page]);

  return (
    <Fragment>
      {themeKey && (
        <Helmet
          link={[
            {
              rel: 'stylesheet',
              href: `https://fonts.googleapis.com/css?family=${themeFont}`
            },
            {
              rel: 'stylesheet',
              href: `${cloudfront}/${themeKey}.css`
            }
          ]}
        />
      )}
      {page && (
        <Fragment>
          { !CurrentPreview ? (
            <CurrentPage
              page={page}
              pageType={pageType}
              themeKey={themeKey}
            />
          ) : (
            <div className="container-fluid">
              <div className="row">
                <div className="column col-xs-12 col-md-5">
                  <CurrentPage useDragHandle lockAxis="y" />
                  {!isCmsPageFormV2 && <Accordion items={accordionItems}/>}
                </div>
                <div className="column col-md-7 hidden-sm hidden-xs">
                  <CurrentPreview pageType={pageType} />
                </div>
              </div>
            </div>
          )}
        </Fragment>
      )}
    </Fragment>
  );
}

EditPage.propTypes = {
  page: PropTypes.shape({}),
  activateCmsPage: PropTypes.func.isRequired,
  pageKey: PropTypes.string,
  theme: PropTypes.shape({ key: PropTypes.string, font_name: PropTypes.string }),
};

const mapStateToProps = (state, ownProps) => {
  const { byId, typeToId, orderedIds } = state.website.pages;
  const pageKey = ownProps.params.pageKey ? ownProps.params.pageKey.toUpperCase() : undefined;
  const pageId = pageKey ? typeToId[pageKey] : undefined;
  const page = pageId ? byId[pageId] : byId[orderedIds[0]];

  return {
    pageKey,
    page,
    theme: state.wedding.theme,
  };
};

const mapDispatchToProps = dispatch => ({
  activateCmsPage: pageKey => dispatch(activatePage(pageKey)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditPage);



// WEBPACK FOOTER //
// ./src/components/manage/website/EditPage.jsx